/**
 * Created by moort on 1/11/19.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Center from 'react-center';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import SpeakerCard from './SpeakerCard'
import MobileSpeakerCard from './MobileSpeakerCard'
import speakers from './speakers'
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import compose from 'recompose/compose';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({

    speakers:{
        borderTop: '1px solid rgba(0,0,0,.1)',
        // borderBottom: '1px solid rgba(0,0,0,.1)',
        paddingTop: 25
    },
    title: {
        margin: 8,
        padding: 5,
        color: '#FFFFFF',
        backgroundColor: theme.palette.primary.main,
        borderRadius: 4,
        textTransform: 'uppercase',
        verticalAlign: 'middle',
    },
    titleTwo: {
        margin: 8,
        padding: 5,
        color: '#FFFFFF',
        backgroundColor: theme.palette.primary.dark,
        borderRadius: 4,
        textTransform: 'uppercase',
        verticalAlign: 'middle',
    },
    button: {
        margin: 8,
        padding: 5,
        color: '#FFFFFF',
        backgroundColor: theme.palette.primary.main,
        borderRadius: 4,
        textTransform: 'uppercase',
        verticalAlign: 'middle',
    },
    cell:{
        border: "2px solid #ffffff",
        textAlign: 'right'
    },
    cellTwo:{
        borderLeft: "1px solid rgba(0,0,0,.1)",
        borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    cellThree:{
        borderLeft: "1px solid rgba(0,0,0,.1)",
        borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    cellFour:{
        backgroundColor: theme.palette.primary.dark,
        borderLeft: "1px solid rgba(0,0,0,.1)",
        borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    mobileCell:{
        // border: "2px solid #ffffff",
        textAlign: 'left'
    },
    mobileCellTwo:{
        // borderLeft: "1px solid rgba(0,0,0,.1)",
        // borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    mobileCellThree:{
        // borderLeft: "1px solid rgba(0,0,0,.1)",
        // borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    mobileCellFour:{
        backgroundColor: theme.palette.primary.dark,
        // borderLeft: "1px solid rgba(0,0,0,.1)",
        // borderBottom: "2px solid rgba(0,0,0,.1)",
    },
    headerText: {
        fontFamily: 'Montserrat'
    },
    standardTextHeader:{
        fontFamily: 'Montserrat'
    },
    bodyStyle:{
        fontFamily: 'Raleway',
        color: "#1D1B39",
        paddingTop: 50,
        paddingBottom: 50,
        paddingRight: "10%",
        paddingLeft: "10%",
        fontSize: 20
    },
    agendaGrid:{
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        width: '75%',
        fontSize: 16,
    },
    agendaGridMobile: {
        fontFamily: 'Raleway',
        fontWeight: 'bold',
        width: '95%',
        fontSize: 16,
    },
    mobileAgendaHeader: {
        fontFamily: 'Montserrat',
        fontWeight: 'bold',
        fontSize: 26
    },
    mobileAgendaBody: {
        fontFamily: 'Raleway',
        paddingLeft:10
    },
    fortellisHref: {
        color: 'inherit',
        fontFamily: 'Montserrat',
    },
    bigAvatar:{
        width: 200,
        height: 200
    },
    theme:{
        marginLeft:20
    },
    checkboxTalks:{
        marginLeft: 30,
        color: theme.palette.primary.main
    },
    checkboxLab:{
        marginLeft: 10,
        color: theme.palette.primary.dark
    },
    checkboxLabMobile:{
        color: theme.palette.primary.dark
    },
    checkboxTalksMobile:{
        color: theme.palette.primary.main
    },
    speakerMobileContent:{
        marginTop:100,
        padding: 10
    },
    flex: {
        flex: 1,
    }
});


class Agenda extends React.Component {
    constructor(props) {
        super(props);
        const {classes} = props;

        this.state = {
            classes: classes,
            speakers: speakers,
            showBreaks: true,
            showTalks: true,
            agendaLabel:"Extended schedule",
            extendedAgenda: true,
            mobileExtendedAgenda: false,
            open: false,
            selectedSpeaker: {},
            agenda: [
                {
                    timeslot: "9:00 - 9:30 AM",
                    theme:"Welcome note",
                    talk: {
                        title:(
                            <span >
                                Business value and vision of <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> Integration platform
                            </span>
                        ),
                        speakers:[
                            speakers.rajivAmar
                        ],
                        description: (
                            <ul>
                                <li>
                                    Reiterate the vision, journey, current state of the platform and <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> commitment to the industry
                                </li>
                            </ul>
                        )
                    }
                },
                {
                    timeslot: "9:35 - 10:00 AM",
                    theme:(
                        <span>New Announcements & <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> Obligation to Open Platform</span>
                    ),
                    talk: {
                        title:(
                            <span>
                                New capabilities and  announcements. <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> Open Sourcing "<a href="https://ossus.fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis Documentation Framework"</a>
                            </span>
                        ),
                        speakers:[
                            speakers.sahas,
                            speakers.jaredJones
                        ],
                        description: (
                            <ul>
                                <li>Introduce new capabilities (Marketplace, Eventing etc)</li>
                            </ul>
                        )
                    }
                },
                {
                    timeslot: "10:05 - 10:30 AM",
                    theme:(
                        <span>Partnerships accelerate Innovation</span>
                    ),
                    talk: {
                        title:(
                            <span>
                                Build your own "Automotive Digital retailing experience"
                            </span>
                        ),
                        speakers:[
                            speakers.jasonBonifay,
                            speakers.julianBirkett
                        ],
                        description: (
                            <ul>
                                <li>Introduce MVS, Calc and Quote APIs, example use cases</li>
                                <li>Live code demonstrating how to build custom digital retailing experience on the go</li>
                            </ul>
                        )
                    }
                },
                {
                    timeslot: "10:30 - 10:40 AM",
                    breakTime: true,
                    theme:(
                        <span>
                            Break
                        </span>
                    ),
                    talk:(
                        <center>
                            <Avatar alt={"Break Time"} className={classes.bigAvatar} src={require('./images/break.gif')} />
                            <h3 className={classes.headerText}> Did someone say break?</h3>
                        </center>
                    ),
                    description:(
                        <ul>
                            <li>Figure out an exercise regimen</li>
                            <li>Meditate</li>
                            <li>Work on a planner or a bullet journal</li>
                            <li>Call a loved one</li>
                            <li>Step outside for a fresh perspective</li>
                            <li>Close your eyes and take 10 deep breaths</li>
                            <li>Say NO to tension headaches</li>
                            <li>Try people-gazing</li>
                            <li>Stretch out</li>
                            <li>Juggle</li>
                            <li>Make animals of the clouds</li>
                            <li>Eat an apple. S-L-O-W-L-Y</li>
                        </ul>
                    )
                },
                {
                    timeslot: "10:45 - 11:10 AM",
                    theme:(
                        <span>Partnerships accelerate Innovation</span>
                    ),
                    talk: {
                        title:(
                            <span>
                                Ride hailing for dealers
                            </span>
                        ),
                        speakers:[
                            speakers.abramGoldshtein,
                            speakers.kamilRodoper
                        ],
                        description: (
                            <ul>
                                <li>Introduce Lyft partership</li>
                                <li>Introduce Hailer</li>
                                <li>Live code ride hailing assistant to book a ride using Google home and view the booking in Hailer</li>
                            </ul>
                        )
                    }
                },
                {
                    timeslot: "11:15 - 11:40 AM",
                    theme:(
                        <span>Partnerships accelerate Innovation</span>
                    ),
                    talk: {
                        title:(
                            <span>
                                API Economy and How to monetize your APIs
                            </span>
                        ),
                        speakers:[
                            speakers.vinitMehta
                        ],
                        description: (
                            <ul>
                                <li>Strategic talk explaining API economy, metrics from other industries</li>
                                <li>Live code showing how easy it is to expose APIs with <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a></li>
                            </ul>
                        )
                    }
                },
                {
                    timeslot: "11:40 - 12:40 PM",
                    lunch: true,
                    theme:(
                        <span>
                            Lunch provided
                        </span>
                    ),
                    talk:(
                        <span>
                            <center>
                                <Avatar alt={"Lunch Time"} className={classes.bigAvatar} src={require('./images/lunch.gif')} />
                            </center>
                        </span>
                    ),
                    description:(
                        <ul>
                            <li>Eat</li>
                            <li>Mingle</li>
                            <li>Enjoy</li>
                        </ul>
                    )
                },
                // {
                //     timeslot: "12:45 - 1:40 PM",
                //     theme:(
                //         <span>Peek under the hood</span>
                //     ),
                //     talk: {
                //         title:(
                //             <span>
                //                 API Attacks
                //             </span>
                //         ),
                //         speakers:[
                //             speakers.svenEidissen,
                //             speakers.danielNew
                //         ],
                //         description: (
                //             <ul>
                //                 <li>Secure, manage, govern and Monetize your APIs using <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> integration platform</li>
                //                 <li>Live code showing how <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a> helps API providers on
                //                     <ul>
                //                         <li>bot prevention</li>
                //                         <li>api abuse prevention</li>
                //                         <li>ddos, encryption, brute force attack prevention</li>
                //                     </ul>
                //                 </li>
                //             </ul>
                //         )
                //     }
                // },
                {
                    timeslot: "12:45 - 4:10 PM",
                    lab: true,
                    theme:(
                        <span>
                            Hands On Lab
                        </span>
                    ),
                    talk:(

                        <center>
                            <Avatar alt={"Lunch Time"} className={classes.bigAvatar} src={require('./images/hol.gif')} />
                        </center>
                    ),
                    description:(
                        <span>
                            <ul>
                                <li>Track - 1: Onboard APIs, Onboard Real time notification providers</li>
                                <li>Track - 2: Building solution leveraging existing APIs</li>
                            </ul>
                        </span>
                    )
                },
                {
                    timeslot: "4:15 - 5:10 PM",
                    theme:(
                        <span>Showcase & Celebrate</span>
                    ),
                    talk: {
                        title:(
                            <span>
                               Showcase what was built at the event. Closing note with What's Next on <a href="https://fortellis.io/" className={classes.fortellisHref} target="_blank">Fortellis</a>.
                            </span>
                        ),
                        speakers:[
                            speakers.brandonBoyd
                        ],
                        description: (
                            <ul>
                                <li>Showcase/Demo</li>
                                <li>Talk about
                                    <ul>
                                        <li>Login with Fortellis-Id experience</li>
                                        <li>Real time eventing platform</li>
                                        <li>Data Streaming platform</li>
                                        <li>Marketplace</li>
                                    </ul>
                                </li>
                            </ul>
                        )
                    }
                }
            ]
        }

    }
    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleAgendaChange(value){
        this.setState({extendedAgenda:!this.state.extendedAgenda})
    }

    handleMobileAgendaChange(value){
        this.setState({mobileExtendedAgenda :!this.state.mobileExtendedAgenda})
    }

    filterTalks() {
        this.setState({showTalks:!this.state.showTalks})
    }

    filterBreaks(){
        this.setState({showBreaks:!this.state.showBreaks})
    }

    showSpeakerPopUp(speaker){
        this.setState({ selectedSpeaker: speaker, open: true });
    }

    getAgenda(){
        let grid = [];
        for(let i = 0; i < this.state.agenda.length; i++){
            let agendaEntry = this.state.agenda[i];
            if(agendaEntry.lunch || agendaEntry.lab || agendaEntry.breakTime){
                grid.push(
                    this.state.showBreaks ?
                        <Grid key={i.toString()} item md={2} lg={2} xl={2} className={this.state.classes.cell}>
                            {agendaEntry.timeslot}
                        </Grid>
                    :null
                )
                grid.push(
                    this.state.showBreaks ?
                        <Grid key={i.toString()+"Next"} item xs={10} className={this.state.classes.cellThree}>
                            <div className={this.state.classes.titleTwo}>
                                {agendaEntry.theme}
                            </div>
                            {this.state.extendedAgenda ? <br/>:null}
                            {this.state.extendedAgenda ? agendaEntry.description:null}
                        </Grid>
                    :null
                )
            }
            else{
                let speakers = [];
                for(let j = 0; j < agendaEntry.talk.speakers.length; j++){
                    let speaker = agendaEntry.talk.speakers[j];
                    speakers.push(
                        <SpeakerCard
                            key={j.toString()+"_"+i.toString()+"Speaker"}
                            showSpeakerPopUp={this.showSpeakerPopUp.bind(this)}
                            speakerAvatar={speaker.speakerAvatar}
                            speakerName={speaker.speakerName}
                            speakerTitle={speaker.speakerTitle}
                            speakerBio={speaker.speakerBio}
                            speakerLinkedIn={speaker.speakerLinkedIn}
                            speakerTwitter={speaker.speakerTwitter}
                            speakerEmail={speaker.speakerEmail}
                        />
                    )
                }

                grid.push(
                    this.state.showTalks ?
                        <Grid key={i.toString()} item md={2} lg={2} xl={2} className={this.state.classes.cell}>
                            {agendaEntry.timeslot}
                        </Grid>
                    :null
                );

                grid.push(
                    this.state.showTalks ?
                        <Grid key={i.toString()+"Next"} item md={10} lg={10} xl={10} className={this.state.classes.cellTwo}>
                            <div className={this.state.classes.title}>
                                {agendaEntry.talk.title}
                            </div>
                            {this.state.extendedAgenda ? <br/>:null}
                            {this.state.extendedAgenda ? <span className={this.state.classes.theme}>{agendaEntry.theme}</span> : null}
                            {this.state.extendedAgenda ? <br/>:null}
                            {this.state.extendedAgenda ? agendaEntry.talk.description:null}
                            {this.state.extendedAgenda ? <br/>:null}
                            {this.state.extendedAgenda ?
                                <div className={this.state.classes.speakers}>
                                    Speakers
                                    {speakers}
                                </div> : null}
                        </Grid>
                    :null
                )

            }

        }

        return grid;
    }

    getMobileAgenda(){
        let grid = [];
        for(let i = 0; i < this.state.agenda.length; i++){
            let agendaEntry = this.state.agenda[i];
            if(agendaEntry.lunch || agendaEntry.lab || agendaEntry.breakTime){
                grid.push(
                    this.state.showBreaks ?
                        <Grid key={i.toString()} item md={12} lg={12} xl={12} className={this.state.classes.mobileCell}>
                            {agendaEntry.timeslot}
                        </Grid>
                        :null
                )
                grid.push(
                    this.state.showBreaks ?
                        <Grid key={i.toString()+"NextMobile"} item xs={12} className={this.state.classes.mobileCellThree}>
                            <div className={this.state.classes.titleTwo}>
                                {agendaEntry.theme}
                            </div>
                            {this.state.mobileExtendedAgenda ? <br/>:null}
                            {this.state.mobileExtendedAgenda ? agendaEntry.description:null}
                        </Grid>
                        :null
                )

            }
            else{
                let speakers = [];
                for(let j = 0; j < agendaEntry.talk.speakers.length; j++){
                    let speaker = agendaEntry.talk.speakers[j];
                    speakers.push(
                        <MobileSpeakerCard
                            key={j.toString()+"_"+i.toString()+"SpeakerMobile"}
                            showSpeakerPopUp={this.showSpeakerPopUp.bind(this)}
                            speakerAvatar={speaker.speakerAvatar}
                            speakerName={speaker.speakerName}
                            speakerTitle={speaker.speakerTitle}
                            speakerBio={speaker.speakerBio}
                            speakerLinkedIn={speaker.speakerLinkedIn}
                            speakerTwitter={speaker.speakerTwitter}
                            speakerEmail={speaker.speakerEmail}
                        />
                    )
                }

                grid.push(
                    this.state.showTalks ?
                        <Grid key={i.toString()} item sm={12} xs={12} className={this.state.classes.mobileCell}>
                            {agendaEntry.timeslot}
                        </Grid>
                        :null
                );

                grid.push(
                    this.state.showTalks ?
                    <Grid key={i.toString()+"NextMobile"} item sm={12} xs={12} className={this.state.classes.mobileCellTwo}>
                        <div className={this.state.classes.title}>
                            {agendaEntry.talk.title}
                        </div>
                        {this.state.mobileExtendedAgenda ? <br/>:null}
                        {this.state.mobileExtendedAgenda ? <span className={this.state.classes.theme}>{agendaEntry.theme}</span> : null}
                        {this.state.mobileExtendedAgenda ? <br/>:null}
                        {this.state.mobileExtendedAgenda ? agendaEntry.talk.description:null}
                        {this.state.mobileExtendedAgenda ? <br/>:null}
                        {this.state.mobileExtendedAgenda ?
                            <div className={this.state.classes.speakers}>
                                Speakers
                                {speakers}
                            </div> : null}
                    </Grid>
                        :null
                );

            }

        }

        return grid;
    }

    render() {
        const { fullScreen } = this.props;
        return (
            <div className={this.state.classes.bodyStyle}>
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <Hidden smDown>
                        <DialogTitle id="responsive-dialog-title">{this.state.selectedSpeaker.speakerName}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <SpeakerCard
                                    hideShowMore={true}
                                    speakerAvatar={this.state.selectedSpeaker.speakerAvatar}
                                    speakerName={this.state.selectedSpeaker.speakerName}
                                    speakerTitle={this.state.selectedSpeaker.speakerTitle}
                                    speakerBio={this.state.selectedSpeaker.speakerBio}
                                    speakerLinkedIn={this.state.selectedSpeaker.speakerLinkedIn}
                                    speakerTwitter={this.state.selectedSpeaker.speakerTwitter}
                                    speakerEmail={this.state.selectedSpeaker.speakerEmail}
                                />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                <CloseIcon /> <Typography>Close</Typography>
                            </Button>

                        </DialogActions>
                    </Hidden>
                    <Hidden only={['lg', 'xl', 'md']} >
                        <AppBar className={this.state.classes.appBar}>
                            <Toolbar>
                                <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit" className={this.state.classes.flex}>
                                    {this.state.selectedSpeaker.speakerName}
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div className={this.state.classes.speakerMobileContent}>
                            <SpeakerCard
                                hideShowMore={true}
                                speakerAvatar={this.state.selectedSpeaker.speakerAvatar}
                                speakerName={this.state.selectedSpeaker.speakerName}
                                speakerTitle={this.state.selectedSpeaker.speakerTitle}
                                speakerBio={this.state.selectedSpeaker.speakerBio}
                                speakerLinkedIn={this.state.selectedSpeaker.speakerLinkedIn}
                                speakerTwitter={this.state.selectedSpeaker.speakerTwitter}
                                speakerEmail={this.state.selectedSpeaker.speakerEmail}
                            />
                        </div>
                    </Hidden>
                </Dialog>
                <Hidden mdDown>
                    <Center>
                        <Grid container spacing={24} className={this.state.classes.agendaGrid}>
                            <Grid item md={12} lg={12} xl={12}>
                                <h3 className={this.state.classes.standardTextHeader}><b>Thursday</b><small>, January 24th, 2019</small></h3>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.extendedAgenda}
                                            onChange={this.handleAgendaChange.bind(this)}
                                        />
                                    }
                                    labelPlacement="start"
                                    label={this.state.agendaLabel}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={this.state.classes.checkboxTalks}
                                            checked={this.state.showTalks}
                                            onChange={this.filterTalks.bind(this)}
                                            value="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Talks"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={this.state.classes.checkboxLab}
                                            checked={this.state.showBreaks}
                                            onChange={this.filterBreaks.bind(this)}
                                            value="checkedB"
                                            color={"#6B2574"}
                                        />
                                    }
                                    label="Breaks and labs"
                                />
                            </Grid>

                            {this.getAgenda()}
                        </Grid>
                    </Center>
                </Hidden>
                <Hidden only={['lg', 'xl']} >
                    <Center>
                        <Grid container spacing={24} className={this.state.classes.agendaGridMobile}>
                            <Grid item sx={5} sm={5} md={5}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.mobileExtendedAgenda}
                                            onChange={this.handleMobileAgendaChange.bind(this)}
                                        />
                                    }
                                    labelPlacement="start"
                                    label={this.state.agendaLabel}
                                />
                            </Grid>
                            <Grid item md={7} lg={7} xl={7}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={this.state.classes.checkboxTalksMobile}
                                            checked={this.state.showTalks}
                                            onChange={this.filterTalks.bind(this)}
                                            value="checkedB"
                                            color="primary"
                                        />
                                    }
                                    label="Talks"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={this.state.classes.checkboxLabMobile}
                                            checked={this.state.showBreaks}
                                            onChange={this.filterBreaks.bind(this)}
                                            value="checkedB"
                                            color={"#6B2574"}
                                        />
                                    }
                                    label="Breaks and labs"
                                />
                            </Grid>
                            <Grid item sx={12} sm={12} md={12}>
                                <h3 className={this.state.classes.standardTextHeader}><b>Thursday</b><small>, January 24th, 2019</small></h3>
                            </Grid>
                            {this.getMobileAgenda()}
                        </Grid>
                    </Center>
                </Hidden>
                <Center>
                    <h3 className={this.state.classes.headerText}>Do you have questions about (dev)day? <a href="mailto:Fortellis Team <info@fortellis.io>">Email the Fortellis team</a>.</h3>
                </Center>
            </div>
        );
    }
}

Agenda.propTypes = {
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

// export default withStyles(styles)(Agenda);
export default compose(
    withStyles(styles),
    withMobileDialog()
)(Agenda);